import { Pencil, Trash2, Info } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';
import type { IExpenseResult } from '../../../../models/expense/ExpenseModel';
import styles from '../ExpenseManagement.module.css';

export type ExpenseManagementActionCellProps = {
  row: IExpenseResult;
};

const ExpenseManagementActionCell = ({ row }: ExpenseManagementActionCellProps) => {
  const { popupStore, expenseStore } = useStore();

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    expenseStore.setSelectedExpense(row);
    popupStore.setIsEditExpenseOpen(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (row.id) {
      expenseStore.setExpenseToDelete(row);
      popupStore.setIsDeleteExpenseConfirmationOpen(true);
    }
  };

  const handleDetail = (e: React.MouseEvent) => {
    e.stopPropagation();
    expenseStore.setSelectedExpense(row);
    popupStore.setIsExpenseDetailOpen(true);
  };

  return (
    <div className={styles.actionCell}>
      <button onClick={handleEdit} className={styles.editButton} title="Düzenle">
        <Pencil size={16} strokeWidth={2} />
      </button>
      <button onClick={handleDelete} className={styles.deleteButton} title="Sil">
        <Trash2 size={16} strokeWidth={2} />
      </button>
      <button onClick={handleDetail} className={styles.infoButton} title="Detay">
        <Info size={16} strokeWidth={2} />
      </button>
    </div>
  );
};

export default observer(ExpenseManagementActionCell);
